import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';

import Icon from '@mdi/react';
import { mdiArrowRightThin } from '@mdi/js';

// img
import AboutUsImg1 from "../../images/about-img-1.jpg";
import AboutUsImg2 from "../../images/about-img-2.jpg";
import CircleEffect from "../../images/circle.png";

export default function AboutUs() {
    return (
        <>
            <section className='section about-us-section mb-xl-5' id='about'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className='section-title-box'>
                                <h1 className='section-title'><span className='text-primary'>About</span> Us</h1>
                            </div>
                        </Col>
                    </Row>

                    <Row className='align-items-center'>
                        <Col lg={5}>
                            <div className='about-us-img d-inline-block mb-lg-0 mb-5'>
                                <img src={AboutUsImg1} alt="" className='img-fluid about-img' />
                                <img src={CircleEffect} alt="" className='circle-img' />
                            </div>
                        </Col>
                        <Col lg={{ span: 6, offset: 1 }}>
                            <h1 className='fw-semibold mb-4'>We Are The Best And Trusted <span className='text-primary'>Real Estate</span> Agent</h1>
                            <p className='text-muted fs-16'>Our commitment to excellence drives us to deliver the most competitive real estate deals on the market. Whether you're looking for a cozy home or a lucrative investment property, we offer a diverse range of options tailored to meet your needs and budget.</p>
                            <p className='text-muted fs-16 mb-4'>With a deep understanding of the market and a passion for customer satisfaction, we ensure that every transaction is seamless and rewarding. Trust us to guide you through the process, offering expert advice and unparalleled support every step of the way.</p>
                            <Row>
                                <Col xl={10}>
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header><i className="bi bi-question-lg me-2 text-primary fs-26"></i> What types of real estate deals do you offer?</Accordion.Header>
                                            <Accordion.Body>
                                                We offer a variety of deals including residential homes, commercial properties, and investment opportunities tailored to meet different needs and budgets.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header><i className="bi bi-question-lg me-2 text-primary fs-26"></i> How do I know if a property is a good deal?</Accordion.Header>
                                            <Accordion.Body>
                                                Our experienced team evaluates each property based on market trends, location, and potential returns to ensure you’re getting the best value.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header><i className="bi bi-question-lg me-2 text-primary fs-26"></i> Can you help with financing options?</Accordion.Header>
                                            <Accordion.Body>
                                                Yes, we work with trusted financial partners to help you explore the best mortgage and financing solutions for your purchase.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='section about-us-section mb-xl-5'>
                <Container>
                    <Row className='align-items-center pb-xl-4'>

                        <Col lg={{ span: 5, offset: 1 }} className='order-lg-2'>
                            <div className='about-us-img d-inline-block mb-lg-0 mb-5'>
                                <img src={AboutUsImg2} alt="" className='img-fluid about-img' />
                                <img src={CircleEffect} alt="" className='circle-img' />
                            </div>
                        </Col>
                        <Col lg={6} className='order-lg-1'>
                            <h1 className='fw-semibold mb-4 me-xl-5'>We Are Offernig The Best <span className='text-primary'>Real Estate</span> Deals</h1>
                            <p className='text-muted fs-16 mb-4'>At Homle, we understand that finding the perfect property at the right price can be challenging. That’s why we’re dedicated to presenting the best deals in the market, with properties that combine value, location, and amenities. Whether you’re a first-time buyer, an investor, or looking for a dream home, our exclusive offers cater to a range of needs and budgets. Each property is thoroughly evaluated, ensuring that our clients receive unmatched value and an exceptional experience.</p>
                            <ul className='list-unstyled fs-15 mb-4'>
                                <li className='d-flex align-items-center mb-2'><Icon path={mdiArrowRightThin} className='icon-size-24 text-primary me-2' />Access to exclusive deals and competitive pricing in prime locations.</li>
                                <li className='d-flex align-items-center mb-2'><Icon path={mdiArrowRightThin} className='icon-size-24 text-primary me-2' />Dedicated to helping you find the perfect property to match your goals.</li>
                                <li className='d-flex align-items-center mb-2'><Icon path={mdiArrowRightThin} className='icon-size-24 text-primary me-2' />Unmatched market insights and industry expertise.</li>
                            </ul>
                            <Row>
                                <Col sm={6}>
                                    <div className="d-flex align-items-center p-2 border border-light shadow-sm rounded mb-3">
                                        <div className="flex-shrink-0">
                                            <div className='avatar avatar-sm fs-15 bg-soft-primary rounded text-primary'>
                                                <i className="bi bi-currency-dollar"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 fs-18 fw-semibold">
                                            Affordable Prices
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center p-2 border border-light shadow-sm rounded mb-3">
                                        <div className="flex-shrink-0">
                                            <div className='avatar avatar-sm bg-soft-primary rounded text-primary'>
                                                <i className="bi bi-geo-alt"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 fs-18 fw-semibold">
                                            Prime Locations
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center p-2 border border-light shadow-sm rounded mb-3">
                                        <div className="flex-shrink-0">
                                            <div className='avatar avatar-sm bg-soft-primary rounded text-primary'>
                                                <i className="bi bi-graph-up-arrow"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 fs-18 fw-semibold">
                                            High Investment Returns
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={6}>
                                    <div className="d-flex align-items-center p-2 border border-light shadow-sm rounded mb-3">
                                        <div className="flex-shrink-0">
                                            <div className='avatar avatar-sm bg-soft-primary rounded text-primary'>
                                                <i className="bi bi-briefcase"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 fs-18 fw-semibold">
                                            Expert Guidance
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center p-2 border border-light shadow-sm rounded mb-3">
                                        <div className="flex-shrink-0">
                                            <div className='avatar avatar-sm bg-soft-primary rounded text-primary'>
                                                <i className="bi bi-currency-dollar"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 fs-18 fw-semibold">
                                            Secure Transactions
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center p-2 border border-light shadow-sm rounded mb-3">
                                        <div className="flex-shrink-0">
                                            <div className='avatar avatar-sm bg-soft-primary rounded text-primary'>
                                                <i className="bi bi-shield-lock"></i>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1 ms-3 fs-18 fw-semibold">
                                            Diverse Property Options
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
